import { inject, Injectable } from '@angular/core';
import { LoadingController, LoadingOptions } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly loadingController: LoadingController = inject(LoadingController);

  private loadingRefCount: number = 0;
  private activeLoading: HTMLIonLoadingElement | null = null;

  async showLoading(opts?: LoadingOptions): Promise<void> {
    this.loadingRefCount++;

    if (this.loadingRefCount === 1) {
      const loading: HTMLIonLoadingElement = await this.loadingController.create({
        ...opts,
        spinner: opts?.spinner ?? 'bubbles',
        duration: opts?.duration ?? 5000,
        cssClass: 'ion-loading-bg-none'
      });

      this.activeLoading = loading;
      await loading.present();
    }
  }

  dismissLoading(): void {
    this.loadingRefCount = Math.max(0, this.loadingRefCount - 1);

    if (this.loadingRefCount === 0 && this.activeLoading) {
      this.activeLoading.dismiss();
      this.activeLoading = null;
    }
  }

  async dismissAllLoadings(): Promise<void> {
    this.loadingRefCount = 0;
    if (this.activeLoading) {
      await this.activeLoading.dismiss();
      this.activeLoading = null;
    }
  }
}
